import { useState, useEffect } from 'react';
import './Pipeline.css';

const STEPS = [
  { num: '01', icon: '📄', name: 'PDF Input',       tech: 'Any PDF, any size' },
  { num: '02', icon: '⚙️', name: 'Text Reading',    tech: 'Background processing' },
  { num: '03', icon: '👁', name: 'Language Scan',   tech: 'On-device reading' },
  { num: '04', icon: '🏷', name: 'Auto-Tagging',    tech: 'Smart categorization' },
  { num: '05', icon: '🗄', name: 'Local Save',      tech: 'Stored on your phone' },
];

export default function Pipeline() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % STEPS.length);
    }, 1600);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="pipeline" id="pipeline">
      <div className="section-label reveal">Processing pipeline</div>
      <div className="pipeline-track">
        {STEPS.map((s, i) => (
          <div
            key={i}
            className={`pipeline-step${active === i ? ' active' : ''}`}
            onMouseEnter={() => setActive(i)}
          >
            <div className="step-num">{s.num}</div>
            <div className="step-icon">{s.icon}</div>
            <div className="step-name">{s.name}</div>
            <div className="step-tech">{s.tech}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
